import { BaseResponseDto } from '@/models/dtos/baseReponseDto'
import { EndpointsAdmin } from '@/admin/services/_endpoints.admin'
import axios from 'axios'
import { EmployeeTypeDto } from '@/models/dtos/employeeTypeDto'

export abstract class EmployeeTypeAdminService {
  static async get(id: string): Promise<EmployeeTypeDto> {
    const result = await axios
      .get<BaseResponseDto<EmployeeTypeDto>>(EndpointsAdmin.employeeType.get, {
        params: {
          id
        }
      })

    if (!result?.data?.dto) throw new Error('Cannot get employeeType')

    return result.data.dto
  }

  static async getAll(): Promise<EmployeeTypeDto[]> {
    const result = await axios
      .get<BaseResponseDto<EmployeeTypeDto[]>>(EndpointsAdmin.employeeType.getAll)

    if (!result.data.dto) return []

    return result.data.dto
  }

  static async add(employeeType: EmployeeTypeDto): Promise<string> {
    const result = await axios
      .post<BaseResponseDto<string>>(EndpointsAdmin.employeeType.add, employeeType)

    return result.data.dto!
  }

  static async edit(employeeType: EmployeeTypeDto): Promise<void> {
    await axios
      .put<BaseResponseDto<any>>(EndpointsAdmin.employeeType.edit, employeeType)
  }

  static async remove(id: string): Promise<void> {
    await axios
      .delete<BaseResponseDto<any>>(EndpointsAdmin.employeeType.remove, {
        params: {
          id
        }
      })
  }
}
